import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { getMyRole } from './client';
import { keys } from './keys';

/**
 * The caller's tenant role (ADR-0071 §1) — Owner / Admin / Member. UX only: it
 * decides which Agent Monitor pages are SHOWN; every page's API re-checks the
 * role server-side. Long-lived: a role changes by an Owner action, not mid-turn.
 */
export function useRole() {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.role(),
    queryFn: ({ signal }) => getMyRole({ getAccessToken, signal }),
    staleTime: 10 * 60_000,
    select: (res) => res.data.role,
  });
}
